import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useAuth } from '../auth/AuthProvider';

/**
 * The root path is a signpost, not a page.
 *
 * There is no "platform home" to show anyone: an underwriter's home is the
 * workbench, and a platform admin's is the console. What used to live here was
 * a session card listing the caller's subject, tenant and roles — useful while
 * the identity layer was being built, and a dead end for everyone since.
 *
 * Clients are set up in the Platform Admin console, which is where an ADMIN
 * lands, so neither role needs an intermediate screen to choose from.
 */
export function Landing() {
  const { user, loading, login, roles } = useAuth();

  // No anonymous surface: a signed-out visit (including the post-logout
  // redirect) goes straight to the Keycloak login screen.
  useEffect(() => {
    if (!loading && !user) login();
  }, [loading, user, login]);

  if (loading || !user) {
    return (
      <Box className="flex justify-center py-12">
        <CircularProgress />
      </Box>
    );
  }

  return <Navigate to={roles.includes('ADMIN') ? '/admin' : '/workbench'} replace />;
}
